import React from 'react';
import PropTypes from 'prop-types';
import FocusableTrigger from './FocusableTrigger';
import Translate from './Translate';

const Pager = ({
  additionalClassName,
  current,
  nextDisabled,
  nextStep,
  prevDisabled,
  prevStep,
  total,
}) => {
  let nextClassName = 'booking-steps-pager__forward';
  let previousClassName = 'booking-steps-pager__prev';
  let rootClassName = 'booking-steps-pager group';

  if (nextDisabled) {
    nextClassName += ' booking-steps-pager__forward--disabled';
  }

  if (prevDisabled) {
    previousClassName += ' booking-steps-pager__prev--disabled';
  }

  if (additionalClassName) {
    rootClassName += ` ${additionalClassName}`;
  }

  return (
    <section className={rootClassName}>

      <FocusableTrigger
        className={previousClassName}
        href=""
        onClick={prevStep}
      >
        <Translate content="Previous" />
      </FocusableTrigger>

      <div className="booking-steps-pager__page">
        <span className="current">{current}</span>
        /
        <span className="total">{total}</span>
      </div>

      <FocusableTrigger
        className={nextClassName}
        href=""
        onClick={nextStep}
      >
        <Translate content="Next" />
      </FocusableTrigger>

    </section>
  );
};

Pager.PropTypes = {
  additionalClassName:PropTypes.string,
  current:PropTypes.number.isRequired,
  nextDisabled:PropTypes.bool,
  nextStep:PropTypes.func.isRequired,
  prevStep:PropTypes.func.isRequired,
  prevDisabled:PropTypes.bool,
  total:PropTypes.number.isRequired,
};

export default Pager;
